/*
 * Copyright (c) 2020. Legalbird eine Marke der R&S Internet Jewels GmbH
 */

import React from "react";
import Container from "../../../Container/Container";
import Grid from "@mui/material/Grid";
import kindsOfDivorceSectionStyle from "./kindsOfDivorceSectionStyle";
import ExpandablePaper from "../../../ExpandablePaper/ExpandablePaper";
import Typography from "@mui/material/Typography";

const KindsOfDivorceSection = () => {
  return (
    <Container sx={kindsOfDivorceSectionStyle.container}>
      <Typography variant={"h2"} sx={kindsOfDivorceSectionStyle.header}>
        Vier Arten von Scheidungen
      </Typography>
      <Grid container spacing={2}>
        <Grid
          size={{
            xs: 12,
            md: 6
          }}>
          <ExpandablePaper header={"Einvernehmliche Scheidung"}>
            <Typography sx={kindsOfDivorceSectionStyle.text}>
              Wenn die Ehepartner ein Jahr getrennt leben und beide die Scheidung wollen, ist eine einvernehmliche Scheidung möglich. Zudem müssen sich die
              Ehepartner über den Ehegattenunterhalt und die Verteilung von Besitz, Wohnung und Hausrat einig sein. Bei gemeinsamen, minderjährigen Kindern
              müssen zusätzlich das Sorgerecht, Umgangsrecht und der Kindesunterhalt geregelt werden.
            </Typography>
          </ExpandablePaper>
        </Grid>
        <Grid
          size={{
            xs: 12,
            md: 6
          }}>
          <ExpandablePaper header={"Streitige Scheidung"}>
            <Typography sx={kindsOfDivorceSectionStyle.text}>
              Wenn sich die Ehepartner bezüglich der Scheidung allgemein, oder Themen, wie dem Unterhalt oder Sorgerecht uneinig sind, handelt es sich um eine
              streitige Scheidung. In diesem Fall ist es wichtig, dem Gericht die Scheidungsgründe mitzuteilen und auch zu beweisen, wenn der Ehepartner diese
              abstreitet. Bei einer streitigen Scheidung brauchen beide Ehepartner einen Anwalt und es kann zu einem langwierigen Prozess kommen.
            </Typography>
          </ExpandablePaper>
        </Grid>
        <Grid
          size={{
            xs: 12,
            md: 6
          }}>
          <ExpandablePaper header={"Nach mehr als 3 Jahren Trennung"}>
            <Typography sx={kindsOfDivorceSectionStyle.text}>
              Wenn die Ehepartner 3 Jahre getrennt leben, gilt die Ehe per Gesetz automatisch als gescheitert. Dem Gericht muss daher nur dargelegt werden, dass
              die Ehepartner seit 3 Jahren getrennt leben. Auf den Grund der Scheidung kommt es in diesem Fall nicht an. Nach 3 Jahren Trennung wird die Ehe
              auch geschieden, wenn der andere Ehegatte der Scheidung widerspricht.
            </Typography>
          </ExpandablePaper>
        </Grid>
        <Grid
          size={{
            xs: 12,
            md: 6
          }}>
          <ExpandablePaper header={"Härtefall Scheidung"}>
            <Typography sx={kindsOfDivorceSectionStyle.text}>
              Auch wenn beide Ehepartner die Scheidung wollen, ist diese bei einer Trennungszeit von weniger als einem Jahr nur möglich, wenn ein Härtefall
              vorliegt. Ein Härtefall ist z. B., wenn der Antragsteller vom Partner misshandelt wurde, der Partner mit jemand anderem ein Kind erwartet, oder er
              Alkoholiker/drogenabhängig ist. Eine kurze Ehe ist hingegen kein Härtefall. Auch bei einer kurzen Ehe bleibt somit das Trennungsjahr
              verpflichtend.
            </Typography>
          </ExpandablePaper>
        </Grid>
      </Grid>
    </Container>
  );
};

export default KindsOfDivorceSection;
